export interface AppConfig {
  VITE_APP_API_KEY: string;
  VITE_APP_API_BASE_URL: string;
  VITE_NODE_ENV: string;
  VITE_APP_EMPLOYEE_SALT: string;
  VITE_APP_DEV_SENTRY_DNS: string;
  VITE_INTERCOM_APP_ID: string;
  VITE_APP_AMPLITUDE_API_KEY: string;
  VITE_APP_ADDITIONAL_DATA_BASE_URL: string;
  VITE_APP_DISABLE_TENANT_FETCH: string;
  // Google reCAPTCHA v3 site key. Used by the auth-route provider
  // (src/routes/RecaptchaLayout.tsx). Optional — degrades gracefully when unset.
  VITE_APP_RECAPTCHA_SITE_KEY?: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

export function getConfig(): AppConfig {
  return (window.__APP_CONFIG__ ?? {}) as AppConfig;
}
